/**
 * Maps Authorize.Net customer payment profile creditCard.cardType to AP_Payment.CreditCardType.description.
 * Canonical DB description for Discover is "Discover" (legacy rows may still use "Discovery").
 */
export function dbDescriptionFromAuthorizeNetCardType(cardType) {
  if (!cardType) return null;
  const map = {
    Visa: "VISA",
    MasterCard: "Master Card",
    AmericanExpress: "American Express",
    Discover: "Discover",
    DinersClub: "Diners Club",
    JCB: "JCB",
  };
  return map[cardType] || null;
}

export function isDiscoverCardType(description) {
  return description === "Discover" || description === "Discovery";
}

/** Fallback when Authorize.Net cardType cannot be matched to CreditCardType rows. */
export function resolveCcTypeIdFallback(authNetCardType, creditCardTypes = []) {
  const matched = findCreditCardTypeRow(creditCardTypes, authNetCardType);
  if (matched) return matched.id;
  if (authNetCardType === "MasterCard") {
    const mc = creditCardTypes.find((t) => t.description === "Master Card" || t.description === "MasterCard");
    return mc ? mc.id : 3;
  }
  if (authNetCardType === "Discover") {
    const disc = creditCardTypes.find((t) => isDiscoverCardType(t.description));
    return disc ? disc.id : 5;
  }
  if (authNetCardType === "Visa") {
    const visa = creditCardTypes.find((t) => t.description === "VISA");
    return visa ? visa.id : 4;
  }
  return 4;
}

export function findCreditCardTypeRow(creditCardTypes, authNetCardType) {
  if (!creditCardTypes || !creditCardTypes.length) return null;
  const want = dbDescriptionFromAuthorizeNetCardType(authNetCardType);
  if (!want) return null;
  let row = creditCardTypes.find((t) => t.description === want);
  // DB may use "MasterCard" or "Master Card"
  if (!row && want === "Master Card") {
    row = creditCardTypes.find((t) => t.description === "MasterCard" || t.description === "Master Card");
  }
  // Legacy CCOS/APL rows may still use "Discovery"
  if (!row && want === "Discover") {
    row = creditCardTypes.find((t) => t.description === "Discovery");
  }
  return row || null;
}
